module.exports = __webpack_public_path__ + "static/media/file-medical-alt.7bb2c00d.svg";